import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToDiagnosticExaminationApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { ReferralToDiagnosticExaminationFormBean } from '../ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

import { mapReferralToDiagnosticExaminationFormBeanToReferralCommandDetails } from './ReferralToDiagnosticExaminationSendAction.utils';

export const useReferralToDiagnosticExaminationConfirmAndPrintCommand = (
   visitId: number,
   onSuccess: PromiseVoidFunction
): UseCqrsCommandResult<PaperReferralApprovalResult, ReferralToDiagnosticExaminationFormBean> => {
   const handleSuccess = useReferralPrintCommandSuccessHandler({
      visitId: visitId,
      onPrintDone: onSuccess,
   });

   return useCqrsCommand<PaperReferralApprovalResult, ReferralToDiagnosticExaminationFormBean>(
      (parameters) => {
         const command = new VisitReferralToDiagnosticExaminationApproveCommand();
         command.visitId = visitId;
         command.referralDetails = mapReferralToDiagnosticExaminationFormBeanToReferralCommandDetails(
            parameters,
            false
         );
         return command;
      },
      {
         onSuccess: handleSuccess,
      }
   );
};
